import { PartyPopper, ArrowRight } from 'lucide-react';
import Modal from '../../core/ui/Modal';
import Button from '../../core/ui/Button';
import './CheckoutSuccessModal.css';

type Props = {
    open: boolean;
    onClose: () => void;
    planName?: string | undefined;
};

/**
 * Celebration modal shown after a successful Stripe checkout redirect.
 * Reinforces the purchase decision and guides the user to their new features.
 */
function CheckoutSuccessModal({ open, onClose, planName }: Props) {
    return (
        <Modal open={open} onClose={onClose} size="sm" ariaLabel="Subscription activated">
            <Modal.Body>
                <div className="checkout-success">
                    <div className="checkout-success__icon">
                        <PartyPopper size={36} />
                    </div>
                    <h2 className="checkout-success__title">
                        {planName ? `Welcome to ${planName}!` : 'Subscription activated!'}
                    </h2>
                    <p className="checkout-success__desc">
                        Your account has been upgraded. All premium features are now unlocked.
                    </p>
                    <Button variant="primary" size="lg" fullWidth icon={<ArrowRight size={18} />} onClick={onClose}>
                        Start exploring
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default CheckoutSuccessModal;
